import './styles.scss'

import React from 'react'
import PropTypes from 'prop-types'

import I18n from 'lib/i18n'
import Slider from 'lib/components/slider'

import Course from './course'

const SimilarCourses = ({ courses, dpr }) => {
  return (
    <div className='row'>
      <div className='twelve columns mt-30'>
        <h3 className='similar-related'>{I18n.t('courses.show.similar_classes')}</h3>
        <Slider>
          {courses.map(course => (
            <Course key={course.id} width={130} course={course} dpr={dpr} />
          ))}
        </Slider>
      </div>
    </div>
  )
}

SimilarCourses.propTypes = {
  courses: PropTypes.array,
  dpr: PropTypes.number
}

export default SimilarCourses
